import React from 'react';
import PropTypes from 'prop-types';

import Img from '../../../../Img';
import { LOCK_ICON_SRC } from '../performanceStatsUtils';
import styles from '../performanceStats.scss';

function LockedChartOverlay({ onClick, 'data-testid': dataTestId }) {
    return (
        <button type="button" className={styles.lockOverlayBtn} onClick={onClick} data-testid={dataTestId}>
            <Img src={LOCK_ICON_SRC} alt="locked" className={styles.lockOverlayIcon} />
        </button>
    );
}

LockedChartOverlay.propTypes = {
    onClick: PropTypes.func.isRequired,
    'data-testid': PropTypes.string,
};

LockedChartOverlay.defaultProps = {
    'data-testid': null,
};

export default LockedChartOverlay;
